import React from "react";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../../styles/styles-css-variables";
import { CSS_MQ } from "../../../styles/breakpoints";
import { SwarovskiLink } from "../../_shared-components/ui-elements/SwarovskiLink";
import { FooterSection } from "@swo/storefront";
import { FONTS, fontSize } from "../../../styles/fonts";

export const FooterNavigationPrimary: React.FC<{ data: FooterSection }> = props => {
  return (
    <React.Fragment>
      {props.data.map((nav, idx) => {
        return (
          <SwarovskiLink
            key={JSON.stringify(nav)}
            link={nav.link}
            isInternal={true}
            scrollToTop
            attachStyles={css`
              display: block;
              text-decoration: none;

              font-family: MinervaModern;

              --font-size: 30px;
              ${CSS_MQ.atLeastMd} {
                --font-size: 40px;
              }

              font-size: var(--font-size);

              text-transform: uppercase;

              margin-bottom: 20px;
              color: ${CSS_COLORS.White};
            `}
          >
            {nav.label}
          </SwarovskiLink>
        );
      })}
    </React.Fragment>
  );
};

const styles = [
  FONTS.SwarovskiFutura500,
  fontSize.x2,
  css`
    display: block;
    text-decoration: none;

    text-transform: uppercase;

    margin-bottom: 20px;
    color: ${CSS_COLORS.White};
  `,
];

export const FooterNavigationSecondary: React.FC<{ data: FooterSection; cookieSettingsLabel: string }> = props => {
  return (
    <React.Fragment>
      <hr
        css={css`
          max-width: 100px;

          margin-bottom: 20px;
          margin-left: 0;
        `}
      />
      {props.data.map((nav, idx) => {
        return (
          <SwarovskiLink key={JSON.stringify(nav)} link={nav.link} isInternal={true} scrollToTop attachStyles={styles}>
            {nav.label}
          </SwarovskiLink>
        );
      })}

      <button
        onClick={() => {
          const uc = (window as any).UC_UI;

          if (uc && typeof uc.showSecondLayer === "function") {
            uc.showSecondLayer();
          } else {
            alert(`Cookie settings are temporarily not available.`);
          }
        }}
        css={styles}
      >
        {props.cookieSettingsLabel}
      </button>
    </React.Fragment>
  );
};
